import { useTranslation } from "react-i18next";
import { useSignalRMessage } from "../../application/signalr";
import { useAppDispatch, useAppSelector } from "../../framework/redux/hooks";
import {
    AlertType,
    WorkTimeTypeDrawerState,
    addAlert,
    deleteAlertByType,
    toggleWorkTimeTypeDrawer,
} from "../../framework/redux/slices/appSlice";
import { AlertSeverity } from "../../models/common/enums";
import { WorkShiftTimeSlotEvent } from "../../models/common/hubmessage";
import { handleApiError } from "../../services/baseService";
import { fetchCurrentWorkShift } from "../../framework/redux/slices/workShiftSlice";

export const workTimeAutomationAlertDuration = 15000;

export const useListenWorkTimeMessages = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const drawerState = useAppSelector(({ app }) => app.drawer);

    const discardVehicleStopped = () =>
        dispatch(
            toggleWorkTimeTypeDrawer(
                drawerState === WorkTimeTypeDrawerState.PendingOpen
                    ? WorkTimeTypeDrawerState.None
                    : WorkTimeTypeDrawerState.PendingClose
            )
        );

    useSignalRMessage("WorkShiftTimeSlotStarted", (msg) => {
        discardVehicleStopped();
        dispatch(fetchCurrentWorkShift())
            .then(() => {
                dispatch(
                    addAlert({
                        message:
                            msg.event === WorkShiftTimeSlotEvent.VehicleDriving
                                ? t("workTime.drivingSlotStarted")
                                : msg.workTimeTypeName
                                    ? t("workTime.workTimeTypeUpdated", {
                                        type: msg.workTimeTypeName,
                                    })
                                    : t("workTime.workStarted"),
                        severity: AlertSeverity.Info,
                        duration: workTimeAutomationAlertDuration,
                    })
                );
            })
            .catch(handleApiError);
    });

    useSignalRMessage("WorkShiftTimeSlotFinished", () => {
        discardVehicleStopped();
        dispatch(fetchCurrentWorkShift())
            .then(() => {
                dispatch(
                    addAlert({
                        message: t("workTime.workFinished"),
                        severity: AlertSeverity.Info,
                        duration: workTimeAutomationAlertDuration,
                    })
                );
            })
            .catch(handleApiError);
    });

    useSignalRMessage("VehicleStopped", () => {
        dispatch(fetchCurrentWorkShift())
            .then(() => {
                dispatch(
                    toggleWorkTimeTypeDrawer(
                        WorkTimeTypeDrawerState.PendingOpen
                    )
                );
            })
            .catch(handleApiError);
    });

    useSignalRMessage("VehicleMoving", () => {
        discardVehicleStopped();
        dispatch(deleteAlertByType(AlertType.VehicleStopped));
    });
};
